// extracted by mini-css-extract-plugin
export var hideEditor = "_m1-2";
export var infoIcon = "_m1-3";
export var label = "_m1-1";
export var labelContainer = "_m1-0";
export var readonlyText = "_m1-4";